/**
 * Calculate savings for yearly plans
 */
export const calculateSavings = (plan) => {
    if (plan.price === "Contact us") return 0;
    const monthlyTotal = parseFloat(plan.price) * 12;
    const yearlyTotal = parseFloat(plan.priceYearly) * 12;
    return monthlyTotal - yearlyTotal;
};

/**
 * Helper function to determine if a plan is an upgrade or downgrade
 */
export const getPlanComparison = (plan, currentPlanDetails, currentSubscription, isInTrial, currentPlanId, isYearly) => {
    if (!currentPlanDetails || !currentSubscription || isInTrial) {
        return null; // No comparison if no current plan or in trial
    }

    // Get current plan price (use yearly if current subscription is yearly)
    const isCurrentYearly =
        currentPlanId === currentPlanDetails.priceIdYearly ||
        currentPlanId === currentPlanDetails.devPriceIdYearly;
    const currentPrice = isCurrentYearly
        ? parseFloat(currentPlanDetails.priceYearly || 0)
        : parseFloat(currentPlanDetails.price || 0);

    // Get target plan price
    const targetPrice = isYearly
        ? parseFloat(plan.priceYearly || 0)
        : parseFloat(plan.price || 0);

    if (plan.price === "Contact us") {
        return null; // Can't compare with enterprise
    }

    if (targetPrice > currentPrice) {
        return "upgrade";
    } else if (targetPrice < currentPrice) {
        return "downgrade";
    } else {
        return "same"; // Same price (might be switching billing cycle)
    }
};

/**
 * Get product ID based on environment
 */
export const getProductId = (plan) => {
    const isDev = window.location.hostname === "localhost";
    return isDev && plan.devProductId ? plan.devProductId : plan.productId;
};
